'use client';

import React, { Component } from 'react';
import './style.sass';
import '../reusable-components/style.sass';

import Results from '../reusable-components/layouts-components__mid/results';
import Tasks from '../reusable-components/layouts-components__mid/tasks';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Complex from '../reusable-components/layouts-components__mid/complex';
import Process from '../reusable-components/layouts-components__mid/process';
import Conclusions from '../reusable-components/layouts-components__mid/conclusions';
import Team from '../reusable-components/layouts-components__mid/team';
import Goal from '../reusable-components/layouts-components__mid/goal';
import Review from '../reusable-components/layouts-components__common-cases/review';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const midMainTitle = {
    titleMainText: `Помогли Колледжу МИД России собрать в&nbsp;3&nbsp;раза больше заявок на&nbsp;поступление абитуриентов`,
    titleAnimation: '/images/pic/preview/mid.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#157fc4',
            nameText: 'Колледж Министерства иностранных дел Российской Федерации',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#157fc4',
            nameText: 'Образование',
        },
        {
            modeText: 'Услуги',
            colorMode: '#157fc4',
            nameText: 'Настройка контекстной и&nbsp;таргетированной рекламы',
        },
        {
            modeText: 'Технологии',
            colorMode: '#157fc4',
            nameText: 'Яндекс.Директ, Google Ads, Facebook Ads, ВКонтакте',
        },
    ],
};

const reviewMid = {
    reviewText: `Вместе с&nbsp;командой Вебпрактик мы&nbsp;смогли собрать заявок на&nbsp;поступление из&nbsp;интернета даже больше, чем ожидали. И&nbsp;это несмотря на&nbsp;пандемию и&nbsp;самоизоляцию, которые сильно усложнили приёмную кампанию-2020. Многие привычные нам офлайн-инструменты привлечения абитуриентов оказались недоступны. Но&nbsp;специалисты, работающие с&nbsp;нами, не&nbsp;просто исполняют готовое техзадание. Они сами предлагают новые инструменты продвижения и&nbsp;корректируют уже работающие, снимая с&nbsp;нас вопросы анализа и&nbsp;планирования даже в&nbsp;сложных ситуациях. Мы&nbsp;можем рекомендовать это агентство всем, кому важно сохранить и&nbsp;даже улучшить показатели эффективности при любом кризисе.`,
    reviewAuthors: [
        {
            title: 'Маргарита Фролова',
            subtitle: 'менеджер по рекламе и связям с общественностью Колледжа МИД',
            img: '/images/pic/mid/reviewimg.png',
        },
    ],
    downLoadPresentationText: '&nbsp; Получить презентацию кейса',
};

const nextProjectGge = {
    nextProjectTitle:
        'Продвижение сообщества AdventureLand Технопарка «Сколково» на венчурном рынке',
    nextProjectImg: '/images/pic/preview/AdventureLand.png',
    nextProjectLink: '/cases/marketing/adventureland',
    nextProjectLinkTitle: 'Технопарк «Сколково»',
    nextProjectText:
        'Как мы работаем, чтобы AdventureLand стал крупнейшим сообществом, в котором стартапы получают инвестиции: рекламные кампании для сложного венчурного рынка.',
};

class Mid extends Component {
    render() {
        return (
            <section className="mid">
                <MainTitle MainTitle={midMainTitle}>
                    <CommonSmallTitle className="mid__subtitle">
                        Колледж МИД России
                    </CommonSmallTitle>
                    <CommonSmallText>
                        С&nbsp;1993 года Колледж готовит специалистов по&nbsp;документационному
                        обеспечению управления и&nbsp;архивоведению. Трудоустройство
                        выпускников&nbsp;&mdash; одно из&nbsp;главных направлений деятельности
                        Колледжа. Итогом обучения является возможность выпускника выбирать среди
                        предложений работодателей из&nbsp;загранучреждений, международных
                        организаций, крупнейших государственных и&nbsp;коммерческих структур, среди
                        которых МИД России, Газпром, Лукойл, Сбербанк, ФНС, Государственная Дума
                        Российской Федерации, Аппарат Президента Российской Федерации, ООН, ЮНЕСКО
                        и&nbsp;многие другие.
                    </CommonSmallText>
                </MainTitle>

                <Goal />

                <Tasks />

                <Complex />

                <Process />

                <Conclusions />

                <Results />

                <Team />

                <Review Review={reviewMid} />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectGge} />
            </section>
        );
    }
}

export default Mid;
